import { Offer, NameBanner } from '@rumblefish/ui/Rumblefish23Theme';
import { StyledStack, StyledSection, SectionNameBannerStack } from './styles';
import { StellarDevelopmentProcessData } from './StellarDevelopmentProcess.data';
import type { StellarDevelopmentProcessProps } from './StellarDevelopmentProcess.types';

export const StellarDevelopmentProcess = ({
  ...props
}: StellarDevelopmentProcessProps): React.ReactElement => {
  const customThresholds = [0, 32, 54, 70, 90];

  return (
    <>
      <StyledSection width="normal" id="stellar-development-process">
        <StyledStack {...props}>
          <SectionNameBannerStack>
            <NameBanner
              type="section"
              text="Our Stellar Development Process"
              color="yellow"
            />
          </SectionNameBannerStack>
        </StyledStack>
      </StyledSection>
      <Offer
        title={StellarDevelopmentProcessData.mainText}
        description={StellarDevelopmentProcessData.description}
        data={StellarDevelopmentProcessData.services}
        height={'240px'}
        thresholds={customThresholds}
      />
    </>
  );
};
